export default {
    unassignedOrdersDescription: 'Unzugeordnete Bestellungen sind immer enthalten.',
    today: 'Heute',
    tomorrow: 'Morgen',
    last7Days: 'Letzte 7 Tage',
    last2Weeks: 'Letzte 2 Wochen',
    lastMonth: 'Letzter Monat',
    last3Months: 'Letzte 3 Monate',
    monthToDate: 'Monat bis heute',
    quarterToDate: 'Quartal bis heute',
    yearToDate: 'Jahr bis heute',
    onlyUnassignedOrders: 'Nur unzugeordnete Bestellungen',
    selectMode: 'Modus auswählen',
    selectDateFieldPlaceholder: 'Wählen Sie ein Datumsfeld...',
    reset: 'Zurücksetzen',
    selectStatuses: 'Status auswählen',
    selectDistributionZones: 'Terminal(s) auswählen',
    selectClients: 'Kunde(n) auswählen',
    firebase10Limit: '10 Limit',
    distributionZones: 'Terminals',
    selectCategories: 'Kategorie(n) auswählen',
    selectManufacturers: 'Hersteller(n) auswählen',
    customViews: 'Benutzerdefinierte Ansichten',
    fetchRecords: 'Daten abrufen',
    goToRecords: 'Gehe zu Aufzeichnungen',
    goToRoutes: 'Gehe zu Routen',
    goToMapFleet: 'Gehe zu Karte & Flotte',
    goToReport: 'Gehe zum Bericht',
    goToLiveConnect: 'Gehe zu Live Connect',
    goToAdmin: 'Gehe zu Admin',
    openSearch: 'Suche öffnen',
    createDedicatedOrder: 'Erstelle dedizierte Bestellung',
    createSingleOrder: 'Erstelle Einzelbestellung',
    openBulkImport: 'Bulk-Import öffnen',
    checkBackLater: 'Kommen Sie später wieder für mehr',
    notApplicable: 'Nicht anwendbar',
    warning: 'Warnung',
    language: 'Sprache',
    'Coming Soon': 'Demnächst!',
    loadingMessage: 'BESSERE GESCHÄFTS- UND KUNDENERLEBNISSE FAHREN',
    loadingMessage2: 'Die vollständige Lösung für die Lieferkette',
    loading: 'Lädt...',
    ItemNumber: 'Artikelnummer',
    PrintQuantity: 'Druckmenge',
    internalError: 'Interner Fehler: Bitte kontaktieren Sie das Shyftbase-Team',
    duplicateEntry: '{{value}} existiert bereits. Bitte geben Sie ein anderes {{field}} ein',
    login: {
        selectStore: 'Geschäft auswählen',
        selectRegion: 'Region auswählen',
        selectRole: 'Wählen Sie Ihre Rolle',
        placeholder: {
            email: 'E-Mail..',
            password: 'Passwort..',
            verification: 'Bitte geben Sie hier Ihren Bestätigungscode ein.',
        },
        rules: {
            title: 'Passwort muss enthalten:',
            characters: '8 Zeichen',
            number: 'Zahl enthalten',
            uppercase: 'Großbuchstaben enthalten',
            specialCharacters: 'Sonderzeichen enthalten',
        },
        messages: {
            verification: 'Wir haben Ihnen gerade einen Bestätigungscode geschickt.',
            captchaExpired: 'Sitzung abgelaufen. Bitte versuchen Sie es erneut.',
            redirectingToPortal: 'Warten Sie, wir leiten Sie zum Portal weiter.',
            emailVerification: 'Die E-Mail-Verifizierung wurde gesendet. Bitte überprüfen Sie Ihren Posteingang.',
            invalidAccount: 'Ungültiges Konto.',
            unsupportedAccess: 'Nicht unterstützter Zugriff. Bitte melden Sie sich erneut an.',
            enterVerficationCode: 'Bitte geben Sie Ihren Bestätigungscode ein.',
            somethingWentWrong: 'Etwas ist schief gelaufen. Bitte versuchen Sie es erneut.',
            standardRate: 'Standardtarife können anfallen.',
            firstTimeLogin: 'Haben Sie bereits ein Konto erstellt?',
            goBackToLogin: 'Zurück zum Login',
            goBackToSignup: 'Zurück zur Anmeldung',
            createPassword: 'Erstellen Sie ein neues Passwort',
            confirmPassword: 'Passwort bestätigen',
            notMatch: 'Das Passwort stimmt nicht überein',
            createAccount: 'Konto erstellen',
        },
        button: {
            submit: 'Absenden',
            login: 'Anmelden',
            signup: 'Erstellen Sie Ihr Konto',
        },
        errorCode: {
            'auth/wrong-password': 'Das Passwort ist ungültig oder der Benutzer hat kein Passwort.',
            'auth/user-not-found':
                'Es gibt keinen Benutzerdatensatz für diese Kennung. Der Benutzer wurde möglicherweise gelöscht.',
            'auth/invalid-email': 'Die E-Mail-Adresse ist falsch formatiert.',
        },
        twofa: {
            secureAccess: 'Sicheres Portal',
            sendBtn: 'Senden Sie einen Aktivierungscode',
        },
    },
    dashboard: {
        title: 'Dashboard',
        shyftbaseWatch: 'Shyftbase Übersicht',
        shyftbaseWatchSubtitle: 'Shyftbase Watch wird aktiviert, sobald genügend Daten gesammelt wurden',
        shyftbaseWatchModal: {
            title: 'Shyftbase Übersicht',
            message: 'Shyftbase Watch wird aktiviert, sobald genügend Daten gesammelt wurden.',
            buttonText: 'Zu Records-Registerkarte gehen',
            closeAriaLabel: 'Modal schließen',
        },
        operationsOverview: 'Operationsübersicht',
        orderCount: 'Bestellanzahl',
        unconfirmedPercent: 'Unbestätigt %',
        confirmedPercent: 'Bestätigt %',
        invoicedPercent: 'In Rechnung gestellt %',
        activeRoutes: 'Aktive Routen',
        fleetUtilization: 'Flottenauslastung',
        avgDeliveryTime: 'Durchschn. Lieferzeit',
        ordersNeedingAttention: 'Bestellungen, die Aufmerksamkeit benötigen',
        noOrdersNeedAttention: 'Derzeit benötigen keine Bestellungen Aufmerksamkeit.',
        noOrdersDescription: 'Wenn Sie Bestellungen haben, die Maßnahmen erfordern, werden sie hier mit Details wie:',
        noOrdersExamples: {
            addressVerification: 'Adressenverifizierung erforderlich',
            schedulingConflicts: 'Lieferzeitplanungskonflikte',
            paymentVerification: 'Zahlungsverifizierung ausstehend',
            specialHandling: 'Besondere Handhabungsanforderungen',
        },
        recommendations: 'Empfehlungen',
        noRecommendations: 'Noch keine Empfehlungen verfügbar.',
        noRecommendationsDescription: 'Während Ihr System Betriebsdaten sammelt, werden KI-gestützte Einblicke hier angezeigt, einschließlich:',
        noRecommendationsExamples: {
            routeOptimization: 'Routenoptimierungsmöglichkeiten',
            capacityPlanning: 'Kapazitätsplanungsvorschläge',
            preventiveMaintenance: 'Vorbeugende Wartungswarnungen',
            costSaving: 'Kostensparende Empfehlungen',
        },
        quickActions: {
            title: 'Schnellaktionen',
            orderTable: {
                title: 'Bestelltabelle',
                description: 'Live-Versand- und Ops-Konsole',
            },
            uploadCsv: {
                title: 'CSV hochladen',
                description: 'Bestellungen in großen Mengen importieren',
            },
            liveConnect: {
                title: 'Live Connect',
                description: 'Kundenanfragen genehmigen/ablehnen',
            },
            mapFleet: {
                title: 'Flottenkarte',
                description: 'Überwachung von Flotte und Routen',
            },
            search: {
                title: 'Suchen',
                description: 'Kundensupport-Nachschlagen',
            },
            reports: {
                title: 'Berichte',
                description: 'Betriebliche Einblicke',
            },
            admin: {
                title: 'Admin',
                description: 'Einstellungen & Konfiguration',
            },
        },
        dataPending: {
            title: 'Daten werden geladen...',
            description: 'Betriebsdaten erscheinen hier, sobald das System Bestellungen empfängt und verarbeitet.',
        },
    },
    nav: {
        addOrder: '+ Bestellung',
        search: 'Suche',
        orders: 'Bestellungen',
        logout: 'Abmelden',
        tooltip: {
            orders: 'Datensätze, Bestandsartikel und mehr abrufen',
            mapFleet: 'Verwalten Sie Ihre Hubs, Geschäfte und mehr',
            report: 'Shyftbase-Analysen und Berichte',
            assets: 'SKUs',
            trackOrder: 'Bestellungen verfolgen',
            admin: 'Verwalten Sie Ihre Einstellungen und Benutzer',
            help: 'Hilfe und Unterstützung',
            history: 'Verlauf',
            search: 'Suche',
            language: 'Sprache',
            theme: 'Thema',
            profile: 'Profil',
        },
        drawer: {
            handleUiModeMsg: `{{mode}} Modus ist aktiviert.`,
            info: 'Info',
            orders: 'Datensätze',
            assets: 'SKUs',
            mapFleet: 'Flottenkarte',
            billingModule: 'Abrechnungsmodul',
            invoice: 'Rechnung',
            home: 'Startseite',
            search: 'Suche',
            liveConnect: 'Geschäfte',
            trackOrder: 'Verfolgung',
            newOrder: 'Neue Bestellung',
            history: 'Verlauf',
            report: 'Analysen',
            admin: 'Admin',
            logout: 'Abmelden',
            reverseLogistics: 'Umgekehrte Logistik',
            language: 'Sprache',
            help: 'Hilfe',
            installations: 'Installationen',
            logistics: 'Logistik',
            services: 'Dienstleistungen',
            mode: 'Modus',
        },
        header: {
            headerTitle: 'Datensätze',
        },
    },
    search: {
        title: {
            title: 'Sie können nur genehmigte Bestellungen suchen',
            subtitle1: 'Um ausstehende Bestellungen zu suchen, gehen Sie zu ',
            subtitle2: 'ausstehende Bestellungen',
            msg: '* Die Verwendung eines Datumsbereichs wird für eine bessere Leistung und Effizienz empfohlen',
        },
        label: {
            or: 'Oder',
            firstName: 'Vorname',
            lastName: 'Nachname',
            phoneNumber: 'Telefonnummer',
            address: 'Adresse',
            invoice: 'Rechnung # eingeben und Enter drücken',
            from: 'Von (Startzeitraum)',
            to: 'Bis (Endzeitraum)',
            deliveryDate: 'Lieferdatum',
            selectStatus: 'Status auswählen',
            productName: 'Produktname',
            barcode: 'Barcode',
            whid: 'WHID',
            sku: 'SKU',
            invoiceInput: 'Rechnung',
            poNumber: 'PO-Nummer',
            'Scanned In': 'Eingescannt',
            'Scanned Out': 'Ausgescannt',
        },
        button: {
            reset: 'Zurücksetzen',
            search: 'Suchen',
        },
        messages: {
            recordsFound: 'Datensatz(e) gefunden',
            noRecordsFound: 'Keine Datensätze gefunden',
            noInputErr: 'Bitte geben Sie mindestens ein Schlüsselwort ein, um Bestellungen zu suchen.',
            otherErr: 'Etwas ist schief gelaufen. Bitte kontaktieren Sie Shyftbase.',
        },
        'Customer Info': 'Kundendaten',
        'Order Details': 'Bestellungsdetails',
        Statuses: 'Bestellstatus',
        Products: 'Produkte',
        'Reverse Logistics': 'Umgekehrte Logistik',
        'Client Search': 'Kundensuche',
        'Zone Search': 'Zonensuche',
        'Minimize Tags': 'Tags minimieren',
        'Show All Tags': 'Alle Tags anzeigen',
        'Type to show or hide fields': 'Geben Sie ein, um Felder anzuzeigen oder auszublenden',
        'click to show': 'Klicken zum Anzeigen',
        'click to hide': 'Klicken zum Ausblenden',
        selected: 'Ausgewählt',
        'Search For Anything': 'Suche nach allem',
        'Search Input Placeholder':
            'Beispiel: Bestellnummer, Kundenname, Kunde, PO-Nummer, Produkt, Barcode, WHID, SKU',
    },
    liveConnect: {
        orderType: {
            needAttention: 'Braucht Aufmerksamkeit',
            pending: 'Ausstehend (Kundenportal)',
            approved: 'Genehmigt',
            cancelled: 'Abgesagt',
            customerRequest: 'Kundenanfrage',
        },
        region: 'Region',
        store: 'Geschäft',
        invoice: 'Rechnung',
        filter: 'Bestellungen filtern',
        loading: 'Daten werden geladen ...',
    },
    liveOrdersContainer: {
        tooltip: {
            hideStops: 'Haltestellen ausblenden',
            showStops: 'Haltestellen anzeigen',
        },
    },
    bulkImport: {
        messages: {
            duplicateInvoice: `Es gibt doppelte Rechnungen für die ausgewählte Verteilungszone und den Kunden. Bitte überprüfen Sie Ihre Datei und versuchen Sie es erneut.`,
            internealError: 'Bulk-Import fehlgeschlagen. Bitte kontaktieren Sie das Shyftbase-Team.',
            success: 'Erfolgreich importiert.',
        },
        templateSetting: {
            instruction: 'Kopieren Sie Ihren Blatt-Lizenzschlüssel aus dem CSV Box-Konto, das für Sie erstellt wurde.',
            notFound: 'Keine Vorlagen gefunden.',
            downloadInstruction: 'Sie können die Beispieldatei herunterladen, indem Sie auf die Vorlage klicken.',
        },
    },
    rateTable: {
        notDefined:
            'Bitte überprüfen Sie die Preistabelle. Es sind keine verfügbaren Dienstleistungen vorhanden oder die Preistabelle ist nicht definiert.',
        messages: {
            otherErr: 'Etwas ist schief gelaufen. Bitte kontaktieren Sie Shyftbase.',
        },
        connectingLoaderMessage: 'Preise werden verbunden...',
        bulkEdit: {
            submit: 'Absenden',
            close: 'Schließen',
            warning: 'Dies wird die Werte der Preistabelle überschreiben',
            title: 'Massenbearbeitung der Preistabellen',
            success: 'Die Einstellungen der Preistabelle wurden aktualisiert',
            noClients: 'Keine Kunden ausgewählt',
            noDistributionZones: 'Keine Verteilungszonen ausgewählt',
            confirmNullTitle: 'Massenbearbeitung bestätigen',
            confirmNullText: 'Es wurden keine Werte ausgewählt. Alle vorherigen Werte werden entfernt.',
            differentTypeWarning: 'Bitte wählen Sie Preise mit demselben Typ.',
            noData: 'Es wurden keine Werte ausgewählt.',
        },
    },
    liveOrder: {
        orderType: {
            Delivery: 'Lieferung',
            Pickup: 'Abholung',
            'Service Call': 'Serviceanruf',
            'Store-Stop': 'Geschäfts-Stopp',
        },
        cancellationReason: {
            RESCHEDULE: 'NEU PLANEN',
            'NO STOCK': 'KEIN LAGER',
            'CANCELLED BY CUSTOMER': 'VOM KUNDEN ABGESAGT',
            'ADDRESS NOT FOUND': 'ADRESSE NICHT GEFUNDEN',
            'ADULT NOT PRESENT': 'ERWACHSENER NICHT ANWESEND',
            'PREVIOUSLY DONE': 'BEREITS ERLEDIGT',
            'BOOKING ERROR': 'BUCHUNGSFEHLER',
            'CANCELLED BY STORE': 'VOM GESCHÄFT ABGESAGT',
            'CANCELLED TO RESCHEDULE': 'ABGESAGT, UM NEU ZU PLANEN',
            'CREATED - NO STOCK': 'ERSTELLT - KEIN LAGER',
            'DELIVERY TEAM ILLNESS / INJURY': 'KRANKHEIT/VERLETZUNG DES LIEFERTEAMS',
            'DUPLICATE ORDER': 'DUPLIKATBESTELLUNG',
            'FLY BY - NO PRODUCT AVAILABLE': 'FLY BY - KEIN PRODUKT VERFÜGBAR',
            'INCORRECT ADDRESS': 'FALSCHE ADRESSE',
            'INCORRECT ADDRESS - NOT LOADED ON TRUCK': 'FALSCHE ADRESSE - NICHT AUF LASTWAGEN GELADEN',
            'INSUFFICIENT MANPOWER': 'UNGENÜGENDE PERSONENZAHL',
            'INSUFFICIENT MANPOWER - NOT LOADED ON TRUCK': 'UNGENÜGENDE PERSONENZAHL - NICHT AUF LASTWAGEN GELADEN',
            'NAH - OUTSIDE WINDOW': 'NAH - AUSSERHALB DES ZEITRAHMENS',
            'NO STOCK - MID MILE DELAY': 'KEIN LAGER - MITTELSTRECKENVERZÖGERUNG',
            'NO STOCK LOCATED AT HUB': 'KEIN LAGER AM HUB GEFUNDEN',
            'OVERSIZED PRODUCTS(S)': 'ÜBERDIMENSIONIERTE PRODUKTE',
            'PRODUCT NOT LOADED': 'PRODUKT NICHT GELADEN',
            'PROPERTY DAMAGE': 'SCHADEN AM EIGENTUM',
            'PROPERTY NOT ACCESSIBLE': 'EIGENTUM NICHT ZUGÄNGLICH',
            'REFUSED - CONCEALED DAMAGE': 'ABGELEHNT - VERSTECKTER SCHADEN',
            'REFUSED - DRIVER DAMAGE': 'ABGELEHNT - SCHADEN DURCH FAHRER',
            'REFUSED - INCORRECT PRODUCT ORDERED': 'ABGELEHNT - FALSCHE PRODUKTBESTELLUNG',
            'REFUSED - INCORRECT PRODUCT SHIPPED': 'ABGELEHNT - FALSCHE PRODUKTSENDUNG',
            'REFUSED - PRODUCT DEFECTIVE': 'ABGELEHNT - PRODUKTFEHLER',
            'RESCHEDULED BY CUSTOMER - NOT LOADED ON TRUCK': 'VOM KUNDEN NEU GEPLANT - NICHT AUF LASTWAGEN GELADEN',
            'RESCHEDULED BY CUSTOMER': 'VOM KUNDEN NEU GEPLANT',
            'VEHICLE ISSUES': 'FAHRZEUGPROBLEME',
            'WEATHER - NOT LOADED ON TRUCK': 'WETTER - NICHT AUF LASTWAGEN GELADEN',
            'WEATHER ISSUES': 'WETTERPROBLEME',
        },
        orderStatus: {
            'Need Attention': 'Benötigt Aufmerksamkeit',
            Pending: 'Ausstehend (Kundenportal)',
            Cancelled: 'Abgesagt',
            Approved: 'Genehmigt',
        },
    },
    orderEntry: {
        viewPendingOrder: 'Anstehende Bestellungen ansehen',
        title: {
            create: 'Neue Bestellung erstellen',
            update: 'Bestellung aktualisieren',
        },
        subtitle: {
            zone: 'Zone: ',
            pickupDate: 'Abholdatum',
            deliveryDate: 'Lieferdatum',
            scheduledDate: 'Geplantes Datum',
            services: 'Dienstleistungen',
            products: 'Produkte',
        },
        placeholder: {
            placeOrderTakingTimeMessage: 'Dies kann einige Sekunden dauern',
            select: 'Bestelltyp auswählen',
            postalCode: 'Kundenpostleitzahl (Beispiel: L0C1E0)',
            selectReturn: 'Rückgabe-Typ auswählen',
            selectedDate: 'Ausgewähltes Datum: ',
            additionalInfo: 'Zusätzliche Informationen',
        },
        caution: {
            first: 'Wenn Sie eine',
            second: 'Abholung planen,',
            third: 'wählen Sie bitte nur',
            fourth: 'Dienstleistung',
            fifth: 'Option aus.',
        },
        button: {
            check: 'Verfügbarkeiten prüfen',
            submit: 'Absenden',
        },
        messages: {
            submitError:
                'Entschuldigung, die Buchung für diese Postleitzahl ist derzeit nicht möglich! Bitte überprüfen Sie die eingegebene Postleitzahl. Wenn Sie glauben, dass dies ein Fehler ist, senden Sie eine Anfrage, damit diese Postleitzahl zu den unterstützten Zonen hinzugefügt wird, indem Sie eine E-Mail an hcustome@bestbuycanada.ca senden.',
            selectActiveDate: 'Bitte wählen Sie ein aktives Datum',
            saveProduct: 'Bitte stellen Sie sicher, dass die Produkte gespeichert sind!',
            saveService: 'Bitte stellen Sie sicher, dass der Service gespeichert ist!',
            selectDate: 'Bitte stellen Sie sicher, dass ein Datum ausgewählt ist!',
            validInvoice: 'Bitte stellen Sie sicher, dass die Rechnung gültig ist!',
            validInvoiceFormat: 'Bitte stellen Sie sicher, dass das Rechnungsformat "XXX-XXXXXX" in Zahlen ist',
            validPhone: 'Bitte stellen Sie sicher, dass die Telefonnummer gültig ist!',
            validFirstName: 'Bitte stellen Sie sicher, dass der Vorname gültig ist!',
            validLastName: 'Bitte stellen Sie sicher, dass der Nachname gültig ist!',
            validStreet: 'Bitte stellen Sie sicher, dass die Straße gültig ist!',
            validCity: 'Bitte stellen Sie sicher, dass die Stadt gültig ist!',
            validUnit: 'Bitte stellen Sie sicher, dass die Einheitenummer gültig ist!',
            orderAdded: 'Bestellung wurde zur Liste der ausstehenden Bestellungen hinzugefügt!',
            orderUpdated: 'Bestellung wurde erfolgreich aktualisiert!',
            somethingWentWrong:
                'Entschuldigung, etwas ist schief gelaufen. Bitte schließen Sie diese Nachricht und senden Sie sie erneut.',
            lanudryAndFridgeDoorMsg:
                'Bitte bestätigen Sie, dass das zu wartende Gerät neu oder innerhalb von 30 Tagen von Metro To Home gekauft und geliefert wurde.',
            isAccessoriesNew:
                "Sind alle Zubehörteile neu oder gebraucht? Klicken Sie auf 'Ja' für 'Neu', 'Nein' für 'Gebraucht'.",
            haulawayMsg:
                'Bitte beachten Sie, dass Sie einen Abholservice ausgewählt haben, der das Gerät zum Recycling sendet. Bitte stellen Sie sicher, dass der Kunde das Gerät deinstalliert und zur Abholung bereitstellt, bevor unser Team ankommt.',
            largeHawlawayMsg:
                'Bitte beachten Sie, dass unser Abholservice ein One-for-One-Service ist. Bitte überprüfen Sie die angeforderte Menge und reichen Sie sie erneut ein.',
            generateLargeQtyMessage:
                'Dies ist keine reguläre Heimlieferung. Bitte stellen Sie sicher, dass Sie den Prozess für große Bestellungen auf ETK befolgen.',
            generateFourManMessage:
                '4-Mann-Lieferung: Bitte stellen Sie sicher, dass Sie Details, SKU und Menge in den Kommentaren angeben.',
            generateReturnMessage:
                'Rückgabe an DC - Bitte stellen Sie sicher, dass Sie Details (RÜCKGABEGRUND) in den Kommentaren angeben.',
            serviceConditionRequirement: 'Die Servicebedingungen sind nicht erfüllt.',
            generateInvoiceAuthMessage:
                'Entschuldigung, nur der Admin hat die Berechtigung, 900 Bestellungen zu erstellen.',
            oversizeFridge: 'Bitte stellen Sie die Details und SKU/Menge in den Kommentaren zur Verfügung.',
            over90Days:
                'Sie haben ein Datum ausgewählt, das über die 90-Tage-Grenze hinausgeht. Bitte stellen Sie sicher, dass das ausgewählte Datum korrekt ist.',
            usedAccessories:
                'Installationszubehör muss neu und ungeöffnet sein, damit unsere Heimlieferung die Installation abschließen kann.',
            yes: 'Ja',
            no: 'Nein',
            duplicateInovice:
                'Die eingegebene Rechnungsnummer existiert bereits für die ausgewählte Region und Kunden. Bitte geben Sie eine eindeutige Rechnungsnummer ein.',
        },
        options: {
            flyby: 'Fly By',
            serviceCall: 'Nur Service',
            pickup: 'Abholung',
        },
    },
    serviceList: {
        service: 'Service',
        qty: 'Menge',
        remove: 'Entfernen',
    },
    saveServiceForm: {
        selectService: 'Service auswählen',
        saveService: 'Service speichern',
        qty: 'MENGE',
        options: {
            fourMan: '4-Mann-Lieferung - Details in den Kommentaren angeben',
            LevelUnit: 'Einheit nivellieren',
            MoveUnit: 'Einheit an ihren Platz bewegen',
            Pedestal: 'Sockelaufstellung',
            StackingLaundry: 'Wäschestapeln',
            WasherConnection: 'Waschmaschine Anschluss',
            DryerConnection: 'Trockneranschluss',
            WasherandDryerConnection: 'Waschmaschine und Trockner Anschluss',
            FridgeDoorSwing: 'Kühlschranktürschwingen',
            OversizeFridge: 'Übergroßer Kühlschrank (+26/350LB)',
            Haulaway: 'Abholung',
            Doorstep: 'Türschwelle',
        },
    },
    productList: {
        product: 'Produkt',
        qty: 'Menge',
        sku: 'SKU',
        model: 'Modell',
        remove: 'Entfernen',
    },
    saveProductForm: {
        name: 'PRODUKTNAME',
        qty: 'MENGE',
        sku: 'SKU',
        model: 'MODELL',
        save: 'Produkt speichern',
    },
    history: {
        loading: 'Lädt...',
        filter: 'Filtern',
        group: 'Bestellungen gruppieren',
        sort: 'Bestellungen sortieren',
    },
    viewSettings: {
        deleteConfirmation: 'Sind Sie sicher, dass Sie diese Ansicht löschen möchten?',
        deleteWarning: 'Dies wird die Ansicht "{{name}}" und alle ihre Einstellungen löschen.',
        delete: 'Löschen',
        cancel: 'Abbrechen',
        noViews: 'Keine Ansichten gefunden',
        emptyState: {
            title: 'Keine Ansichten verfügbar',
            description: 'Speichern Sie Ihre bevorzugten Filter und Datumsbereiche als Ansichten für späteren Zugriff. Teilen Sie Ansichten mit externen Parteien für schnellen Nur-Lese-Zugriff.',
            createFirstView: 'Erstellen Sie Ihre erste Ansicht, um zu beginnen'
        },
        type: 'Type',
        shareLink: 'Link teilen',
        regions: 'Regionen',
        clients: 'Kunden',
        dateRange: 'Datumsbereich',
        copyLink: 'Link kopieren',
        sharingSettings: 'Freigabe',
        warning: {
            accessClientZones: `Sie haben keinen Zugriff auf die Kunden oder Vertriebszonen dieser Ansicht.`,
            selectView: 'Sie müssen eine neue Ansicht erstellen oder die gespeicherte Ansicht aus dem Ansichtsmenü laden',
            bindClientZones: `Diese Ansicht hat keine verknüpften Kunden und Vertriebszonen. Bitte erstellen Sie eine neue Ansicht mit Verknüpfung`,
        },
        createNewView: 'Neue Ansicht erstellen',
        name: 'Name',
        enterName: 'Geben Sie den Namen der Ansicht ein...',
        configurationSaved: 'Was diese Ansicht speichert',
        visibleColumns: 'Sichtbare Spalten',
        columnOrder: 'Spaltenreihenfolge',
        grouping: 'Gruppierung',
        appliedFilters: 'Angewendete Filter',
        create: 'Ansicht erstellen',
        personal: 'Persönlich',
        shared: 'Geteilt',
        bindClientDistributionzones: 'Aktuelle Kunden, Distributionszonen und Zeitraum speichern',
        bindClientZonesHelp: 'Kunden und Zonen werden mit der Ansicht wieder geladen. Der Zeitraum wird nur für den externen Link gespeichert – im Portal folgt die Ansicht dem von Ihnen ausgewählten Zeitraum. Ohne diese Einstellung verwendet die Ansicht die jeweils ausgewählten Kunden und Zonen und wendet nur die Datumsoption oben an.',
        columnLayoutSaved: 'Das aktuelle Spaltenlayout — welche Spalten sichtbar sind und in welcher Reihenfolge — wird immer gespeichert.',
        shareExternally: 'Teilbaren externen Link erstellen',
        shareExternallyHelp: 'Jeder mit dem Link kann diese Ansicht ohne Anmeldung öffnen. Sie können jederzeit in den Ansichtseinstellungen ein Passwort vergeben, das Kopieren erlauben oder den Link wieder deaktivieren.',
        shareExternallyRequires: 'Aktivieren Sie zuerst die Einstellung oben. Ein geteilter Link hat keinen angemeldeten Benutzer, von dem er Kunden, Zonen und einen Zeitraum übernehmen könnte, und funktioniert daher nur bei einer Ansicht, die diese selbst gespeichert hat.',
        linkAvailableAfterCreate: 'Der Link wird beim Erstellen der Ansicht generiert. Sie können ihn anschließend in den Ansichtseinstellungen kopieren.',
        copyToClipboard: 'Link in die Zwischenablage kopiert. Sie können ihn jetzt teilen',
        hasClientZones: 'Enthält verknüpfte Kunden & Zonen',
        passwordProtected: 'Passwortgeschützt',
        error: {
            fetchFailed: 'Ansichten konnten nicht abgerufen werden. Bitte versuchen Sie es erneut.',
            copyFailed: 'Link konnte nicht kopiert werden. Bitte versuchen Sie es erneut.',
            updateFailed: 'Ansicht konnte nicht aktualisiert werden. Bitte versuchen Sie es erneut.',
            deleteFailed: 'Ansicht konnte nicht gelöscht werden. Bitte versuchen Sie es erneut.',
        },
        sharedView: {
            setPassword: {
                title: 'Ein Passwort ist erforderlich, um diesen Inhalt anzuzeigen',
                subTitle: 'Dieses Passwort ist nicht dasselbe wie Ihr Shyftbase-Kontopasswort',
            },
            allowCopy: 'Datenkopierung zulassen',
            showAllFields: 'Alle Felder in erweiterten Datensätzen anzeigen',
            restrictAccess: 'Durch Passwort einschränken',
            disable: 'Link deaktivieren',
            enable: 'Link aktivieren',
            notAvailable: {
                title: 'Der private Freigabelink, den Sie erreichen wollten, ist nicht verfügbar.',
                subTitle:
                    'Der Besitzer dieser Ansicht hat sie möglicherweise nicht mehr freigegeben oder gelöscht. Bitte kontaktieren Sie ihn, wenn Sie Zugriff benötigen.',
            },
            verifyPassword: 'Passwort eingeben, um Inhalt anzuzeigen',
            wrongPassword: 'Falsches Passwort. Bitte versuchen Sie es erneut.',
        },
        new: 'Neu',
        searchViews: 'Ansichten suchen...',
        personalViews: 'Persönlich',
        noPersonalViews: 'Keine persönlichen Ansichten gefunden.',
        sharedViews: 'Geteilt',
        noSharedViews: 'Keine geteilten Ansichten gefunden.',
        startWindow: 'Startfenster',
        manageSharing: 'Ansichtseinstellungen',
        sharedViaLink: 'Über externen Link geteilt',
        pullScope: 'Abgerufene Daten',
        tableLayout: 'Tabellenlayout',
        groupedBy: 'Gruppiert nach',
        filters: 'Filter',
        notGrouped: 'Nicht gruppiert',
        noFilters: 'Keine Filter',
        dateBasis: 'Datum',
        dateRangeExternalOnly: 'Wird nur vom externen Link verwendet. Im Portal nutzt diese Ansicht immer den von Ihnen ausgewählten Zeitraum.',
        allZones: 'Alle Distributionszonen',
        allClients: 'Alle Kunden',
        none: 'Keine',
        dateOptions: {
            today: 'Heute',
            tomorrow: 'Morgen',
            yesterday: 'Gestern',
            none: 'Kein Datum gespeichert',
        },
        howToUpdate: {
            title: 'So aktualisieren Sie diese Ansicht',
            layout: 'Tabellenlayout — richten Sie Spalten, Gruppierung und Filter im Raster wie gewünscht ein und klicken Sie dann im Panel auf das Speichersymbol dieser Ansicht.',
            scope: 'Kunden, Zonen und Zeitraum — nur Ansichten, die mit den aktuellen Kunden und Distributionszonen gespeichert wurden, behalten diese. Ändern Sie sie im Abrufformular, rufen Sie ab und klicken Sie dann auf Speichern. Der gespeicherte Zeitraum wird nur vom externen Link verwendet; im Portal folgt diese Ansicht immer dem von Ihnen ausgewählten Zeitraum.',
            fixed: 'Name, Modus und die Bindung an bestimmte Kunden und Distributionszonen werden bei der Erstellung festgelegt. Erstellen Sie eine neue Ansicht, um sie zu ändern. (Der Freigabelink oben ist davon nicht betroffen und kann jederzeit ein- und ausgeschaltet werden.)',
        },
    },
    calendarSettings: {
        title: {
            title: 'Kalendereinstellungen',
            selectDistributionZoneAndClient: 'Wählen Sie eine Verteilungszone und einen Kunden aus, um zu starten',
        },
        placeholder: {
            selectZone: 'Zone auswählen',
            selectMonth: 'Monat auswählen',
            selectBDays: 'Werktage auswählen',
        },
        setMaxBooking: 'Maximales Buchungsdatum festlegen',
        subSetMaxBooking: '(Wie weit im Voraus sollten Kunden buchen können)',
        monthFromToday: 'Monat(e) ab heute',
        submit: 'Absenden',
        setEarliestBooking: 'Frühestes verfügbares Datum festlegen, einschließlich heute',
        subSetMinBooking:
            '(z. B. 2 bedeutet, dass das früheste verfügbare Datum nach 2 Werktagen ab dem Buchungsdatum liegt)',
        includingToday: 'Werktage einschließlich heute',
        messages: {
            changePostalCode:
                'Angepasste Tage überschreiben die Postleitzahlpläne. Wenn Sie die Postleitzahlspläne ändern müssen, senden Sie bitte eine E-Mail an admin@shyftbase.com.',
            followingDate: 'das folgende Datum',
            default: 'Zurück zum Standard-Serviceplan basierend auf den Postleitzahlen.',
        },
        colorCodes: 'Farbcodes: ',
        disabledDays: 'Deaktivierte Tage',
        enabledDays: 'Aktivierte Tage',
        select: 'Auswählen',
        enable: 'Aktivieren',
        disable: 'Deaktivieren',
        updateCalener: 'Kalendereinstellungen aktualisieren',
        warning: {
            overwrite:
                'Es gibt vordefinierte Einstellungen für die folgenden Kunden.<br/>Diese Änderungen werden die Einstellungen überschreiben.',
        },
    },
    distributionZoneMapping: {
        subtitle: 'Verteilungszonen-Mapping - Wählen Sie Region zum Starten',
        'Select Region': 'Region auswählen',
        'Select Distribution Zones': 'Verteilungszone eingeben und suchen',
        'Currently Mapped Distribution Zones': 'Aktuell gemappte Verteilungszonen',
        Update: 'Aktualisieren',
        Reset: 'Zurücksetzen',
        None: 'Keine',
        Updated: 'Aktualisiert {0} Verteilungszonen',
        Added: 'Hinzufügt {0} zur Regionenliste',
    },
    clientSetting: {
        error: {
            IncompletForm:
                'Formular ist unvollständig! Geschäftseinheit, Untereinheit, Regionen und Datenquelle dürfen nicht leer sein',
        },
    },
    accessTable: {
        accessLevels: 'Zugriffslevel',
        toggle: 'Zugriffs-Hierarchie umschalten',
        save: 'Speichern',
        searchByName: 'Nach Namen suchen...',
        noUser: 'Keine Benutzer gefunden',
        emailAdmin: '',
        name: 'Name',
        access: 'Zugriff',
        'Create a new one': 'Einen neuen erstellen',
        'User access updated': 'Benutzerzugriff aktualisiert',
        Region: 'Region',
        Actions: 'Aktionen',
        Client: 'Kunde',
        Vendor: 'Lieferant',
    },
    updateOrderInfo: {
        title: 'Bestellung aktualisieren',
        startWindow: 'Startzeitraum',
        selectedDate: 'Ausgewähltes Datum: ',
        services: 'Dienstleistungen',
        products: 'Produkte',
        additionalInfo: 'Zusätzliche Informationen',
        submit: 'Absenden',
        ok: 'OK',
        messages: {
            somethingWentWrong: 'Etwas ist schief gelaufen! Bitte versuchen Sie es erneut.',
            pending: 'Bestellung wurde in die Liste der ausstehenden Bestellungen aktualisiert!',
        },
    },
    orderDisplay: {
        tooltip: {
            confirmUnconfirmBillingState: 'Bestätigen / stornieren Sie den Abrechnungsstatus der Bestellung',
            confirmUnconfirmSettlementState: 'Bestätigen / stornieren Sie den Abrechnungsstatus der Bestellung',
            confirmUnconfirmBothState: 'Umschalten des Abrechnungs- und Abrechnungsstatus der Bestellung',
            lockBillingState:
                'Sperren Sie den Abrechnungsstatus der Bestellung. Dadurch wird verhindert, dass die Bestellung erneut aktualisiert wird, es sei denn, die Bestellung wird nicht bestätigt',
            lockSettlementState:
                'Sperren Sie den Abrechnungsstatus der Bestellung. Dadurch wird verhindert, dass die Bestellung erneut aktualisiert wird, es sei denn, die Bestellung wird nicht bestätigt',
            unlockVehicle: 'Fahrzeug entsperren. Gesperrte Fahrzeuge können nicht mehr aktualisiert werden',
            operationStatus: 'Betriebsstatus',
            serviceList: '{{mode}} Dienstleistungsliste',
        },
    },
    orderDetailModal: {
        requestInfo: 'Anforderungsinfo (Bewege zu Bedarf Aufmerksamkeit)',
        typeMessage: 'Bitte geben Sie Ihre Nachricht ein',
        approve: 'Bestellung genehmigen',
        areYouSure: 'Bist du sicher?',
        yes: 'Ja',
        no: 'Nein',
        cancelOrder: 'Bestellung stornieren',
        update: 'Aktualisieren',
        selectAction: 'Aktion auswählen/Details anzeigen',
    },
    orderDetail: {
        invoice: 'Rechnung / Bestellnummer',
        customer: 'Kunde',
        email: 'E-Mail',
        phone1: 'Telefon 1',
        phone2: 'Telefon 2',
        products: 'Produkte',
        services: 'Dienstleistungen',
        startWindow: 'Startzeitraum',
        address: 'Adresse',
        pickupAddress: 'Abholadresse',
        dispatchComments: 'Versandkommentare',
    },
    cancellationHandler: {
        selectReasonTitle: 'Grund auswählen',
        options: {
            RESCHEDULE: 'NEU PLANEN',
            'NO STOCK': 'KEIN LAGER',
            'CANCELLED BY CUSTOMER': 'VOM KUNDEN ABGESAGT',
            'ADDRESS NOT FOUND': 'ADRESSE NICHT GEFUNDEN',
            'ADULT NOT PRESENT': 'ERWACHSENER NICHT ANWESEND',
            'PREVIOUSLY DONE': 'BEREITS ERLEDIGT',
            'BOOKING ERROR': 'BUCHUNGSFEHLER',
            'CANCELLED BY STORE': 'VOM GESCHÄFT ABGESAGT',
            'CANCELLED TO RESCHEDULE': 'ABGESAGT, UM NEU ZU PLANEN',
            'CREATED - NO STOCK': 'ERSTELLT - KEIN LAGER',
            'DELIVERY TEAM ILLNESS / INJURY': 'KRANKHEIT/VERLETZUNG DES LIEFERTEAMS',
            'DUPLICATE ORDER': 'DUPLIKATBESTELLUNG',
            'FLY BY - NO PRODUCT AVAILABLE': 'FLY BY - KEIN PRODUKT VERFÜGBAR',
            'INCORRECT ADDRESS': 'FALSCHE ADRESSE',
            'INCORRECT ADDRESS - NOT LOADED ON TRUCK': 'FALSCHE ADRESSE - NICHT AUF LASTWAGEN GELADEN',
            'INSUFFICIENT MANPOWER': 'UNGENÜGENDE PERSONENZAHL',
            'INSUFFICIENT MANPOWER - NOT LOADED ON TRUCK': 'UNGENÜGENDE PERSONENZAHL - NICHT AUF LASTWAGEN GELADEN',
            'NAH - OUTSIDE WINDOW': 'NAH - AUSSERHALB DES ZEITRAHMENS',
            'NO STOCK - MID MILE DELAY': 'KEIN LAGER - MITTELSTRECKENVERZÖGERUNG',
            'NO STOCK LOCATED AT HUB': 'KEIN LAGER AM HUB GEFUNDEN',
            'OVERSIZED PRODUCTS(S)': 'ÜBERDIMENSIONIERTE PRODUKTE',
            'PRODUCT NOT LOADED': 'PRODUKT NICHT GELADEN',
            'PROPERTY DAMAGE': 'SCHADEN AM EIGENTUM',
            'PROPERTY NOT ACCESSIBLE': 'EIGENTUM NICHT ZUGÄNGLICH',
            'REFUSED - CONCEALED DAMAGE': 'ABGELEHNT - VERSTECKTER SCHADEN',
            'REFUSED - DRIVER DAMAGE': 'ABGELEHNT - SCHADEN DURCH FAHRER',
            'REFUSED - INCORRECT PRODUCT ORDERED': 'ABGELEHNT - FALSCHE PRODUKTBESTELLUNG',
            'REFUSED - INCORRECT PRODUCT SHIPPED': 'ABGELEHNT - FALSCHE PRODUKTSENDUNG',
            'REFUSED - PRODUCT DEFECTIVE': 'ABGELEHNT - PRODUKTFEHLER',
            'RESCHEDULED BY CUSTOMER - NOT LOADED ON TRUCK': 'VOM KUNDEN NEU GEPLANT - NICHT AUF LASTWAGEN GELADEN',
            'RESCHEDULED BY CUSTOMER': 'VOM KUNDEN NEU GEPLANT',
            'VEHICLE ISSUES': 'FAHRZEUGPROBLEME',
            'WEATHER - NOT LOADED ON TRUCK': 'WETTER - NICHT AUF LASTWAGEN GELADEN',
            'WEATHER ISSUES': 'WETTERPROBLEME',
        },
    },
    orderInfo: {
        placeholder: {
            invoice: 'Rechnung/Wert',
            firstName: 'Vorname',
            lastName: 'Nachname',
            phone1: 'Telefon 1',
            phone2: 'Telefon 2',
            email: 'E-Mail',
            appt: 'Appartement',
            unit: 'Einheit #',
            street: 'Straße / Allee',
            city: 'Stadt / Ort',
            postalCode: 'Postleitzahl',
        },
    },
    bbUserAccessCell: {
        selectOrderType: 'Bestelltyp auswählen',
    },
    chatHistory: {
        title: 'Chatverlauf',
        reply: 'Antworten',
        submit: 'Senden',
    },
    report: {
        dateRangeMsg:
            '* Bei einem Datumsbereich von mehr als 2 Wochen bitte `Umfragebericht herunterladen - Archiv` verwenden',
        liveArchiveDataSourceMsg:
            '* Um sicherzustellen, dass Sie die aktuellsten Ergebnisse vom Vortag haben, laden Sie bitte die Umfrage aus der Live-Datenquelle herunter.',
        download: 'Umfrageberichte herunterladen',
        donwloadFromLiveData: 'Umfragebericht herunterladen - Live-Daten',
        downloadData: 'Daten herunterladen',
        viewReport: 'Bericht anzeigen',
        selectDateRange: 'Datumsbereich auswählen',
        success: 'Bericht wurde erfolgreich heruntergeladen.',
        noDate: 'Datum wurde nicht ausgewählt',
        noRecords:
            'Keine Datensätze gefunden. Bitte wählen Sie einen anderen Datumsbereich und versuchen Sie es erneut',
        noAuth: 'Benutzer nicht autorisiert. Nur autorisierte Mitarbeiter können Berichte herunterladen.',
        liveDataMsg:
            '* Live-Daten: Der Umfang ist auf die Live-Daten beschränkt. Bitte verwenden Sie den Archiv-Export, wenn Sie historische Daten herunterladen möchten.',
        'Download survey report - comments': 'Umfragebericht herunterladen - Kommentare',
    },
    fields: {
        Invoice: 'Rechnung',
        OrderType: 'Auftragsart',
        StartWindow: 'Startfenster',
        EndWindow: 'Endfenster',
        Products: 'Produkte',
        actions: 'Aktionen',
        OrderStatus: 'Auftragsstatus',
        CustomerName: 'Kundenname',
        Phone1: 'Telefon 1',
        Phone2: 'Telefon 2',
        Email: 'E-Mail',
        PickupAddress: 'Abholadresse',
        DropoffAddress: 'Lieferadresse',
        DriverNotes: 'Fahrernotizen',
        DriverServices: 'Fahrerdienstleistungen',
        PlannedServices: 'Geplante Dienstleistungen',
        StartedAt: 'Gestartet um',
        ArrivedAt: 'Angekommen um',
        CompletedAt: 'Abgeschlossen um',
        BestBuyRobocallStatus: 'Robocall-Status',
        BestBuySurveyQ1: 'Umfrage F1',
        BestBuySurveyQ2: 'Umfrage F2',
        BestBuySurveyQ3: 'Umfrage F3',
        BestBuySurveyQ4: 'Umfrage F4',
        BestBuySurveyQ5: 'Umfrage F5',
        BestBuySurveyQ6: 'Umfrage F6',
        BbGiftCustomerEmail: 'Gutschein E-Mail',
        BbGiftAmount: 'Gutscheinbetrag',
        CancellationReason: 'Stornierungsgrund',
        CalledCallCenter: 'Callcenter kontaktiert',
        BbCustomerEmailForSurvey: 'Umfrage E-Mail',
        BbCustomerSurveyComment1: 'Umfrage Kommentar 1',
        BbCustomerSurveyComment2: 'Umfrage Kommentar 2',
        BestBuyRobocallTimestamp: 'Robocall Zeitstempel',
        Services: 'Dienstleistungen',
        Region: 'Region',
        DeliveryAssignee: 'Zugewiesener Lieferant',
        Vehicle: 'Fahrzeug',
        DispatchComments: 'Dispatch-Kommentare',
        ServiceTime: 'Servicezeit',
        DispatchLog: 'Dispatch-Protokoll',
        Store: 'Filiale',
        Pod: 'POD',
        CustomerSignature: 'Kundenunterschrift',
        DistributionZone: 'Vertriebszone',
        Client: 'Kunde',
    },
    vuetableDetailModal: {
        orderInfo: 'AUFTRAGSINFO',
        imageAttachment: 'BILDANHANG',
        productDetail: 'PRODUKTDETAIL',
        product: {
            Product: 'Produkt',
            QTY: 'MENGE',
            SKU: 'SKU',
            WEIGHT: 'GEWICHT',
            MANUFACTURER: 'HERSTELLER',
            VOLUME: 'VOLUMEN',
            SERIAL: 'SERIENNUMMER',
            MODEL: 'MODELL',
            BARCODE: 'BARCODE',
            COMMENT: 'KOMMENTAR',
        },
        driverNotes: 'Fahrernotizen',
        textMsgLogs: 'SMS-Protokoll',
    },
    admin: {
        tooltip: {
            taxRates: 'Steuersätze verwalten',
            integrations: 'Integrationen',
            role: 'Rollen erstellen und verwalten, Feldeinstellungen, Zugangspunkte und Berechtigungen',
            client: 'Kundenprofile einrichten',
            contractor: 'Auftragnehmerprofile einrichten',
            user: 'Benutzer oder Fahrer (Agenten) erstellen und verwalten',
            orderStatus: 'Alle Status im System verwalten',
            calendar: 'Kalender verwalten für Buchungstermine oder Kundenumbuchungen',
            notification: 'Benachrichtigungen und Warnungen verwalten',
            automation: 'Automatisierungseinstellungen verwalten',
            fields: 'Auftragsfeld-Einstellungen verwalten',
            rateTable: 'Benutzerdefinierte Tarife für das automatische Abrechnungsmodul verwalten',
            zones: 'Zonen basierend auf Kilometerbändern, Postleitzahlen oder anderen Kriterien verwalten',
            services: 'Globale Dienstleistungstabelle. Sie können die Dienste später pro Tarif verwalten',
            conditions: 'Abrechnungs- und Abwicklungsbedingungen verwalten',
            tiersEscrow: 'Stufen und Treuhandkonten einrichten',
            fuelSurcharge: 'Kraftstoffzuschläge verwalten',
            weeklyFuelSurcharge: 'Wöchentliche Kraftstoffzuschläge hochladen und verwalten',
            ikeaPostalCodes: 'Postleitzahlen verwalten',
            globalUnits: 'Maßeinheiten verwalten',
        },
        SetupYourBusiness: 'Geschäft einrichten',
        SetupBillingModule: 'Abrechnungsmodul einrichten',
        Automations: 'Automatisierungen',
        Integrations: 'Integrationen',
        'Admin Settings': 'Einstellungen',
        'Your Business, Your Way': 'Ihr Geschäft, Ihre Regeln',
        'Access Table': 'Benutzerzugriffsverwaltung',
        'Admin Action': 'Admin-Aktion',
        'Calendar Settings': 'Kalendereinstellungen',
        'Driver Settings': 'Fahrer',
        'Distribution Zone Mapping': 'Vertriebszonenzuordnung',
        'Client Settings': 'Kunde',
        'Fleet Settings': 'Flotte',
        'Contactless Delivery Settings': 'Kontaktlose Lieferung',
        'Metro Driver Settings': 'Metro-Fahrer',
        'Role Settings': 'Rollen',
        'User Management': 'Benutzerverwaltung',
        'Business Logic Center': 'Geschäftslogik-Zentrum',
        'Client Profile Settings': 'Kundenprofile',
        'Contractor Profile Settings': 'Auftragnehmerprofile',
        'General Settings': 'Allgemein',
        'Notification Settings': 'Benachrichtigungen',
        'Postal Codes': 'Postleitzahlen',
        displayName: 'API-Schlüssel verwalten',
    },
    contractorSettings: {
        error: {
            missingCompanyName: 'Firmenname ist erforderlich',
            missingTier: 'Stufe ist erforderlich',
            duplicateContractor: 'Auftragnehmer existiert bereits',
        },
    },
    driverSettings: {
        Create: 'Erstellen',
        Update: 'Aktualisieren',
        Delete: 'Löschen',
        Confirm: 'Bestätigen',
        Created: '{0} erstellt',
        Updated: '{0} aktualisiert',
        Deleted: 'Gelöscht',
        'Type new name here': 'Neuen Namen hier eingeben',
        'Type Delivery Assignee ID': 'Lieferanten-ID eingeben',
        'is not found': 'wurde nicht gefunden',
        'Type New Contractor To Create': 'Neuen Auftragnehmer zum Erstellen eingeben',
        'No Driver was found in system': 'Kein Fahrer im System gefunden',
    },
    driverInfo: {
        Name: 'Name',
        Company: 'Firma',
        Username: 'Benutzername',
        Password: 'Passwort',
        'Fleet Id': 'Flotten-ID',
        'Read Only': 'Nur lesen',
    },
    newUserForm: {
        'Create a new user': 'Neuen Benutzer erstellen',
        'First Name': 'Vorname',
        'First name is required': 'Vorname ist erforderlich',
        'Invalid first name': 'Ungültiger Vorname',
        'Last Name': 'Nachname',
        'Last name is required': 'Nachname ist erforderlich',
        'Invalid last name': 'Ungültiger Nachname',
        'Store/Admin': 'Filiale / Admin',
        'Store is required': 'Filiale ist erforderlich',
        Admin: 'Admin',
        'Admin is required': 'Admin ist erforderlich',
        Phone: 'Telefon',
        'Phone is required': 'Telefon ist erforderlich',
        'Type only numbers without country code': 'Nur Zahlen ohne Ländervorwahl eingeben',
        Email: 'E-Mail',
        'Email is required': 'E-Mail ist erforderlich',
        'Invalid email': 'Ungültige E-Mail',
        Reset: 'Zurücksetzen',
        'Create user': 'Benutzer erstellen',
        'saved user': ' wurde erfolgreich gespeichert!',
        'Update User': 'Benutzer aktualisieren',
        Close: 'Schließen',
    },
    notification: {
        accessDenied: 'Zugang verweigert. Bitte überprüfen Sie Ihr Zugriffslevel.',
        orderAssignment: 'Auftragszuweisung',
        assigned: 'Zugewiesen',
        unassigned: 'Nicht zugewiesen',
        orderAssignmentSubtitle: 'Nicht zugewiesene Aufträge haben noch kein Ziel-Datum',
        parametersRemoved: '{{parameters}} wurden entfernt, da sie für nicht zugewiesene Aufträge nicht gültig sind.',
    },
    reports: {
        'Select Report Type': 'Berichtstyp',
        'Currently Assigned Recipients': 'Aktuell zugewiesene Empfänger',
        'Type email here': 'E-Mail hier eingeben...',
        'Type Recipients Email and Hit Enter': 'E-Mail des Empfängers eingeben und Enter drücken',
        'Reicipients list updated': 'Empfängerliste aktualisiert',
    },
    Billing: {
        Hello: 'Hallo',
        ViewInvoices: 'Rechnungen anzeigen',
        BackToOverView: 'Zurück zur Übersicht',
        'Last Month Overview': 'Übersicht letzter Monat',
        'Select Month': 'Monat auswählen',
        'Download Supporting Data': 'Unterstützende Daten herunterladen',
        'Download Invoice': 'Rechnung herunterladen',
        'Total Orders': 'Gesamtaufträge',
        Commingled: 'Gemischt',
        Dedicated: 'Dediziert',
        orders: 'Aufträge',
        stops: 'Stopps',
        Scanned: 'Gescannt',
        Returns: 'Retouren',
        'Driver Requests': 'Fahreranfragen',
    },
    forgotPassword: {
        'Reset password link was sent your email': 'Link zum Zurücksetzen des Passworts wurde an Ihre E-Mail gesendet',
        'Reset password': 'Passwort zurücksetzen',
        'Please type your email': 'Bitte geben Sie Ihre E-Mail ein',
        'forgot password': 'Passwort vergessen?',
    },
    generics: {
        yes: 'Ja',
        no: 'Nein',
        ok: 'Ok',
        cancel: 'Abbrechen',
        save: 'Speichern',
        close: 'Schließen',
        delete: 'Löschen',
        edit: 'Bearbeiten',
        add: 'Hinzufügen',
        remove: 'Entfernen',
        update: 'Aktualisieren',
        create: 'Erstellen',
        search: 'Suchen',
        filter: 'Filter',
        volume: 'Volumen',
        weight: 'Gewicht',
    },
    productDetails: {
        Destination: 'Zielort',
        ReverseLogisticsBarcode: 'Retouren-Barcode',
        ServiceTime: 'Servicezeit',
        shyftCodeTooltip: 'Von Shyftbase generierter Barcode',
        Barcode: 'Barcode',
        Shyftcode: 'Shyftcode',
        BolNumber: 'Aktueller Frachtbrief',
        Comment: 'Kommentar',
        Mfr: 'Hersteller',
        Model: 'Modell',
        OriginHub: 'Ursprungshub',
        Product: 'Produkt',
        Quantity: 'Menge',
        Serial: 'Seriennummer',
        Sku: 'Artikelnummer',
        Status: 'Status',
        Volume: 'Volumen',
        Weight: 'Gewicht',
        Id: 'ID',
        PoNumber: 'Bestellnummer',
        PickupByLinehaul: 'Abholung durch Fernverkehr',
        BolHistory: 'Frachtbrief-Historie',
        ShippingDate: 'Versanddatum',
        BolCreatedBy: 'Erstellt von',
        BolOriginHub: 'Ursprungshub',
        BolDestinationHub: 'Zielhub',
    },
    orderTable: {
        updateNotification: {
            info: 'folgende Aufträge aktualisiert',
            warning:
                'Bitte wählen Sie den Auftrag erneut aus, wenn Sie einen davon über das Bearbeitungsfenster oder die Schnellaktion bearbeiten wollten.',
        },
        TimeLockedStatus: {
            warning: 'Das Lieferdatum dieses Auftrags ist gesperrt. Sie können es nicht bearbeiten.',
        },
        VehicleLockedStatus: {
            warning: 'Das Fahrzeug dieses Auftrags ist gesperrt. Sie können es nicht bearbeiten.',
            warningInBulk:
                'Einige der ausgewählten Aufträge haben einen gesperrten Fahrzeugstatus. Sie können ihn nicht bearbeiten.',
        },
        contextMenu: {
            tooltip: {
                billingToggleBoth: 'Abrechnungs- und Abwicklungsstatus umschalten',
                retriggerBillingModule: 'Abrechnungs- und Abwicklungswerte neu berechnen',
                geocodeOneAtAtime: 'Auftrag/Aufträge neu geocodieren. Dies wird das Abrechnungsmodul neu auslösen.',
            },
        },
    },
    help: {
        shyftbaseGuides: 'Shyftbase Anleitungen',
        searchVideoGuides: 'Videoanleitungen nach Thema, Titel oder Stichwort durchsuchen',
        dispatch: 'Disposition',
        routing: 'Routenplanung',
        network: 'Netzwerk',
        admin: 'Administration',
        driver: 'Fahrer',
        inventory: 'Bestand',
        billingModule: 'Abrechnungsmodul',
        howToCreateOrders: 'Wie erstelle ich Aufträge',
        howToDispatchOrders: 'Wie weise ich Aufträge Fahrern zu',
        howToRescheduleOrders: 'Wie plane ich Aufträge um',
        howToPlaceRoboCalls: 'Wie setze ich Robocalls ein',
        howToSearchForAnything: 'Wie suche ich nach allem',
        howToPrintReportsInvoicesAndLabels: 'Wie drucke ich Berichte, Rechnungen und Etiketten',
        howToApproveOrdersFromStores: 'Wie genehmige ich Aufträge von Filialen',
        howToCreateViewsOrShareViews: 'Wie erstelle oder teile ich Ansichten',
        howToUseOrderTableFiltersGroupingsAndSorting:
            'Wie verwende ich Auftragstabellen-Filter, -Gruppierungen und -Sortierung',
    },
    asset: {
        messages: {
            updateSuccess: 'Asset erfolgreich aktualisiert',
            createSuccess: 'Asset erfolgreich erstellt',
            error: 'Etwas ist schief gelaufen. Bitte versuchen Sie es erneut',
            deleteSuccess: 'Asset erfolgreich gelöscht',
            errorDelete: 'Etwas ist schief gelaufen. Bitte versuchen Sie es erneut',
        },
    },
    allFields: {
        actions: 'Aktionen',
        NumberOfDoorRemovals: 'Anzahl Türentfernungen',
        NumberOfExtraPieces: 'Anzahl Zusatzteile',
        NumberOfFridgeLineInstalls: 'Anzahl Kühlschrankinstallationen',
        NumberOfAdjustables: 'Anzahl Einstellbare',
        NumberOfPedInstalls: 'Anzahl Sockelinstallationen',
        NumberOfScrap: 'Anzahl Verschrottungen',
        NumberOfStacks: 'Anzahl Stapel',
        NumberOfWasherDryerInstalls: 'Anzahl Waschmaschinen/Trockner-Installationen',
        Charge100: 'Gebühr 100',
        TotalHours2Man: 'Gesamtstunden 2-Mann',
        TotalHours3Man: 'Gesamtstunden 3-Mann',
        Charge50: 'Gebühr 50',
        AddToCage: 'Zum Käfig hinzufügen',
        DriverServices: 'Fahrerdienstleistungen',
        ApprovedForBilling: 'Zur Abrechnung freigegeben',
        ArchiveStatus: 'Archivstatus',
        ArrivedAt: 'Angekommen um',
        PlannedServices: 'Geplante Dienstleistungen',
        Autobill: 'Automatische Abrechnung',
        AutoContractorBill: 'Automatische Auftragnehmerabrechnung',
        AutoContractorBillEdited: 'Automatische Auftragnehmerabrechnung bearbeitet',
        Barcodes: 'Barcodes',
        BarcodesMatched: 'Barcodes abgeglichen',
        BbCustomerEmailForSurvey: 'BB Kunden-E-Mail für Umfrage',
        BbCustomerSurveyComment1: 'BB Kundenumfrage Kommentar 1',
        BbCustomerSurveyComment2: 'BB Kundenumfrage Kommentar 2',
        BbGiftAmount: 'BB Geschenkbetrag',
        BbGiftCustomerEmail: 'BB Geschenk Kunden-E-Mail',
        BestBuyRobocallStatus: 'Best Buy Robocall-Status',
        BestBuyRobocallTimestamp: 'Best Buy Robocall-Zeitstempel',
        BestBuyRobocallSent: 'Best Buy Robocall gesendet',
        BestBuySurveyQ1: 'Best Buy Umfrage F1',
        BestBuySurveyQ2: 'Best Buy Umfrage F2',
        BestBuySurveyQ3: 'Best Buy Umfrage F3',
        BestBuySurveyQ4: 'Best Buy Umfrage F4',
        BestBuySurveyQ5: 'Best Buy Umfrage F5',
        BestBuySurveyQ6: 'Best Buy Umfrage F6',
        BillingInfo: 'Abrechnungsinformationen',
        BillingValidated: 'Abrechnung validiert',
        CalledCallCenter: 'Callcenter kontaktiert',
        CityDistance: 'Stadtentfernung',
        Client: 'Kunde',
        CoastLocation: 'Küstenstandort',
        OrderStatus: 'Auftragsstatus',
        CompletedAt: 'Abgeschlossen um',
        CompletedStops: 'Abgeschlossene Stopps',
        CancellationReason: 'Stornierungsgrund',
        ContractorName: 'Auftragnehmer Name',
        ContractorPay: 'Auftragnehmer Bezahlung',
        ContractorPayNotes: 'Auftragnehmer Zahlungsnotizen',
        CustomerComment: 'Kundenkommentar',
        CustomerName: 'Kundenname',
        CustomerRating: 'Kundenbewertung',
        CustomerSignature: 'Kundenunterschrift',
        Deductions: 'Abzüge',
        DeliveryAssignee: 'Zugewiesener Lieferant',
        DispatchClosed: 'Disposition geschlossen',
        DispatchComments: 'Dispositionskommentare',
        DispatchLog: 'Dispositionsprotokoll',
        DistributionZone: 'Vertriebszone',
        Driver: 'Fahrer',
        DriverAttachments: 'Fahreranhänge',
        DriverNotes: 'Fahrernotizen',
        DriverTrackingLink: 'Fahrer-Tracking-Link',
        DropoffAddress: 'Lieferadresse',
        DropoffApt: 'Lieferung Apartment',
        DropoffCityTown: 'Lieferung Stadt/Ort',
        DropoffMapUrl: 'Lieferung Google Maps URL',
        DropoffPostalCode: 'Lieferung PLZ',
        DropoffStDr: 'Lieferung Straße',
        DropoffUnit: 'Lieferung Einheit',
        Email: 'E-Mail',
        EndWindow: 'Endfenster',
        EtaLink: 'ETA-Link',
        NumberOfExchanges: 'Anzahl Austausche',
        ExtraAttachments: 'Zusätzliche Anhänge',
        GeoLocation: 'Geo-Standort',
        HourlyWork: 'Stundenarbeit',
        Invoice: 'Rechnung',
        CoastInvType: 'Küsten-Rechnungstyp',
        IsMetroCubeOrigin: 'Ist Metro Cube Ursprung',
        KmDriven: 'Gefahrene KM',
        LastArchived: 'Zuletzt archiviert',
        LastAutobilled: 'Zuletzt automatisch abgerechnet',
        LastMetroUpdate: 'Letzte Metro-Aktualisierung',
        LastTookanSync: 'Letzte Tookan-Synchronisation',
        Latitude: 'Breitengrad',
        Liabilities: 'Verbindlichkeiten',
        LinkedOrder: 'Verknüpfter Auftrag',
        LocationAccuracy: 'Standortgenauigkeit',
        Longitude: 'Längengrad',
        MetroNeedUpdate: 'Metro benötigt Aktualisierung',
        NumberPastDoor: 'Anzahl nach Tür',
        NumberPriorToDoor: 'Anzahl vor Tür',
        NewOrderAttachments: 'Neue Auftragsanhänge',
        NoCharge: 'Keine Gebühr',
        OpsBilling: 'Betriebsabrechnung',
        OpsMargin: 'Betriebsmarge',
        OutOfTown: 'Außerhalb der Stadt',
        OverridePickupApt: 'Abholung Apartment überschreiben',
        OverridePickupCityTown: 'Abholung Stadt/Ort überschreiben',
        OverridePickupPostalCode: 'Abholung PLZ überschreiben',
        OverridePickupStDr: 'Abholung Straße überschreiben',
        OverridePickupUnit: 'Abholung Einheit überschreiben',
        Phone1: 'Telefon 1',
        Phone2: 'Telefon 2',
        ClientSubUnit: 'Kunde Untereinheit',
        PickupAddress: 'Abholadresse',
        PickupApt: 'Abholung Apartment',
        PickupByLinehaul: 'Abholung durch Fernverkehr',
        PickupCityTown: 'Abholung Stadt/Ort',
        PickupMapUrl: 'Abholung Google Maps URL',
        PickupPostalCode: 'Abholung PLZ',
        PickupStDr: 'Abholung Straße',
        PickupUnit: 'Abholung Einheit',
        OrderType: 'Auftragsart',
        PickupCityDistance: 'Abholung Stadtentfernung',
        PickupGeoLocation: 'Abholung Geo-Standort',
        PickupLatitude: 'Abholung Breitengrad',
        PickupLocationAccuracy: 'Abholung Standortgenauigkeit',
        PickupLongitude: 'Abholung Längengrad',
        PlannedStops: 'Geplante Stopps',
        Pod: 'POD',
        ProductCount: 'Produktanzahl',
        ProductJson: 'Produkt JSON',
        Products: 'Produkte',
        ProductsArrival: 'Produkte Ankunft',
        PushTime: 'Push-Zeit',
        DriverPushStatus: 'Fahrer Push-Status',
        ReceivedInWh: 'Im Lager eingegangen',
        Region: 'Region',
        RequestedDeliveryWindow: 'Gewünschtes Lieferfenster',
        ScannedBarcodes: 'Gescannte Barcodes',
        ServiceTime: 'Servicezeit',
        ShippedOut: 'Versandt',
        Skus: 'Artikelnummern',
        StairsOver3rdFloor: 'Treppen über 3. Stock',
        StartWindow: 'Startfenster',
        StartedAt: 'Gestartet um',
        OpsStatuses: 'Betriebsstatus',
        Stem: 'Stamm',
        StemKms: 'Stamm-Kilometer',
        Store: 'Filiale',
        Swamper: 'Helfer',
        SwamperEnd: 'Helfer Ende',
        SwamperStart: 'Helfer Start',
        TextMsgLogs: 'SMS-Protokolle',
        TimeOffset: 'Zeitversatz',
        TookanStatus: 'Tookan-Status',
        TookanId: 'Tookan-ID',
        Vehicle: 'Fahrzeug',
        UniqueOrderId: 'Eindeutige Auftrags-ID',
        User: 'Benutzer',
        VaultId: 'Tresor-ID',
        Volume: 'Volumen',
        WhirlpoolLoadId: 'Whirlpool Ladungs-ID',
        AutoBillEdited: 'Automatische Abrechnung bearbeitet',
        AutoBillComments: 'Automatische Abrechnungskommentare',
        ContractorBillingValidated: 'Auftragnehmerabrechnung validiert',
        FileUploadsDictionary: 'Datei-Upload-Verzeichnis',
        _CreatedTimestamp: 'Erstellungszeitstempel',
        _UpdatedTimestamp: 'Aktualisierungszeitstempel',
        _ImportedTimestamp: 'Import-Zeitstempel',
        _Operation: 'Operation',
    },
    portal: {
        'Main Portal': 'Hauptportal',
        'TV Portal': 'TV-Portal',
        'Same Day Portal': 'Same-Day-Portal',
    },
    contactless: {
        'Type and select zone to map clients': 'Zone eingeben und auswählen, um Kunden zuzuordnen',
        'not exist': 'existiert nicht',
        'Currently Mapped Clients': 'Aktuell zugeordnete Kunden',
        Updated: 'Kontaktlose Liefereinstellungen für {0} aktualisiert',
    },
    orderStatusSettings: {
        success: {
            statusDeleted: 'Status wurde erfolgreich gelöscht',
        },
        warning: {
            cannotDeleteStatus: 'Sie können den Standardstatus nicht löschen',
            error: 'Etwas ist schief gelaufen. Bitte kontaktieren Sie Shyftbase.',
        },
        tooltip: {
            billableSettlementRate: 'Abrechnungs- und Abwicklungssätze, verwendet vom automatischen Abrechnungsmodul',
            ignoreStem: 'Umschalten, um Stamm-Berechnungen anzuwenden',
            ignoreOptimizer: 'Wenn deaktiviert, ignoriert die Routenplanung Aufträge mit diesem Status',
            shouldLock: 'Wenn aktiviert, wird der Auftrag gesperrt und kann nicht aktualisiert werden',
            lifeCycle: 'Definieren Sie die Phase des Lieferzyklus',
        },
    },
    clientSettings: {
        'Create a new client': 'Neuen Kunden erstellen',
        activate: 'Aktivieren',
        deactivate: 'Deaktivieren',
        activated: 'aktiviert',
        deactivated: 'deaktiviert',
        'client name is required': 'Kundenname ist erforderlich',
        'Include in Inventory': 'In Bestand aufnehmen',
        'Client Name': 'Kundenname',
        'Successfully created': 'Erfolgreich erstellt',
        'Client already exists': 'Kunde existiert bereits',
        'No region found': 'Keine Region gefunden',
        'Region is required': 'Region ist erforderlich',
        'Type to search region': 'Tippen Sie, um Region zu suchen',
        Inventory: 'Bestand',
        'Reverse Logistics': 'Retourenlogistik',
        'Include in Reverse Logistics': 'In Retourenlogistik aufnehmen',
        'Send Survey': 'Umfrage senden',
        Yes: 'Ja',
        No: 'Nein',
        'Billing Code': 'Abrechnungscode',
        'Default address': 'Standardadresse',
        'Save changes': 'Änderungen speichern',
        'Upload Survey Logo': 'Umfrage-Logo hochladen',
        'Remove Survey Logo': 'Umfrage-Logo entfernen',
    },
    ikeaDriverSetting: {
        'Select type to proceed': 'Typ zum Fortfahren auswählen',
        loading: 'lädt...',
        drivers: 'Fahrer',
        contractors: 'Auftragnehmer',
        'Create New': 'Neu erstellen',
        Update: 'Aktualisieren',
        Delete: 'Löschen',
        Region: 'Region',
        ID: 'ID',
        Name: 'Name',
        Company: 'Firma',
        'Company Name': 'Firmenname',
        Active: 'Aktiv',
        Submit: 'Absenden',
        Cancel: 'Abbrechen',
        'successfully updated': 'erfolgreich aktualisiert',
        'successfully removed': 'erfolgreich entfernt',
        'No options matching the keyword': 'Keine Optionen passend zum Suchbegriff',
        Select: 'Auswählen',
    },
    dateRegion: {
        dateField: 'Datumsfeld auswählen',
        dateRange: 'Datumsbereich auswählen',
        Records: 'Datensätze',
        firebase10Limit: 'Bis zu 10 oder alle auswählen',
        selectRequiredFields: 'Bitte wählen Sie Datumsfeld, Kunde(n) und Terminal(s) aus',
        orderCountToCheck: {
            one: '{{needToCheckDispatch}} Bestellung erfordert Aufmerksamkeit',
            other: '{{needToCheckDispatch}} Bestellungen erfordern Aufmerksamkeit',
        },
        buttons: {
            addUpload: 'Hinzufügen/Hochladen',
            dedicatedOrder: 'Spezielle Bestellung',
            order: 'Bestellung',
            upload: 'Hochladen',
        },
        supplyChain: {
            status: {
                pending: 'Ausstehend',
                processing: 'In Bearbeitung',
                shipped: 'Versendet',
                delivered: 'Geliefert',
            },
            inventory: {
                low: 'Geringer Bestand',
                outOfStock: 'Nicht vorrätig',
                available: 'Vorrätig',
            },
        },
        customerShipmentNotification: {
            title: 'Neue Kundenlieferungen',
            message: 'Kunden haben Lieferungen über das Portal platziert',
            info: 'Jede Lieferung umfasst normalerweise sowohl Abholung als auch Zustellung',
            closeAriaLabel: 'Benachrichtigung schließen',
        },
    },
    user: {
        deleteUserSuccessMsg: 'Benutzer wurde erfolgreich entfernt.',
        removUserDialogTitle: 'Benutzer entfernen',
        removUserDialogMsg: 'Sie sind dabei, {{email}} zu löschen. Sind Sie sicher?',
    },
}
